import { Button, BUTTON_STATUS } from '@dehaat/dds';
import Image from 'next/image';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useContext, useState } from 'react';
import { UserContext } from '@/context/UserProvider';
import { useAppSelector } from '@/hooks/reduxHooks';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { selectLatLng } from '@/store/features/locationSlice';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import { LocationType } from '@/utils/google';
import HeaderWithBackButton from '../HeaderWithBackButton';
import TextField from '../input/TextField2';
interface Props {
  location: LocationType;
  farmImage: {
    file: Blob;
    filepath: string;
  };
  onContinue: (farmName: string, farmImage: string, location: LocationType) => void;
  onBackClick: VoidFunction;
}
const TakeFarmPhoto = ({
  farmImage,
  onContinue,
  onBackClick,
  location
}: Props) => {
  const {
    t
  } = useTranslation('satellite');
  const [farmName, setFarmName] = useState('');
  const {
    query: {
      sh
    }
  } = useRouter();
  const {
    user
  } = useContext(UserContext);
  const {
    trackCustomEvent
  } = useTriggerEvents();
  let eventParams: Record<string, string | undefined> = {
    FarmerName: user?.full_name,
    FarmerNumber: user?.phone_number
  };
  const latLng = useAppSelector(selectLatLng);
  if (latLng) {
    const [lat, lng] = latLng.split(',');
    eventParams = {
      ...eventParams,
      locationLat: lat,
      locationLong: lng
    };
  }
  if (location?.latitude && location?.longitude) {
    eventParams = {
      ...eventParams,
      userLocationLat: location.latitude.toString(),
      userLocationLong: location.longitude.toString()
    };
  }
  const isContinueButtonDisable = farmName?.length < 3 || !location;
  const handleContinue = () => {
    if (isContinueButtonDisable || !farmImage?.filepath) {
      return;
    }
    trackCustomEvent(CustomEventTypes.SATELLITE_FARM_NAME_ADDED, JSON.stringify({
      ...eventParams,
      farmName
    }));
    onContinue(farmName, farmImage.filepath, location);
  };
  return <>
      {farmImage?.file && <main className="top-0 left-0 z-50 fixed bg-white w-full h-screen overflow-y-auto">
          {sh != 'f' && <HeaderWithBackButton heading={t('farm_name')} showHomeIcon={false} showProfileIcon={false} onBackClick={() => onBackClick()} />}
          <section className={`p-4 ${sh != 'f' ? 'pt-16' : 'pt-8'}`}>
            <Image src={URL.createObjectURL(farmImage.file)} alt="farm-image" width={800} height={600} className="m-auto mt-4 mb-8 rounded-lg max-h-[50vh] w-auto h-auto object-contain" />

            <TextField value={farmName} label={t('farm_name')} name="name" onChange={e => setFarmName(e.target.value)} required />
          </section>
          <footer className="bottom-0 left-0 fixed bg-white shadow-[0_-2px_6px_rgba(0,0,0,0.10)] p-4 w-full">
            <Button onClick={handleContinue} text={t('continue')} size={3} status={!isContinueButtonDisable ? BUTTON_STATUS.ACTIVE : BUTTON_STATUS.DISABLED} />
          </footer>
        </main>}
    </>;
};
export default TakeFarmPhoto;